// use-fetch-data.js
import { useEffect, useState } from 'react';
import axios from 'axios';

const useFetchData = ({ url, isEnabled = true }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isEnabled) {
      return;
    }

    const fetchData = async () => {
      try {
        const { data: response } = await axios.get(`/wp-json/api/adpt${url}`);
        setData(response);
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    };

    fetchData();
  }, [url, isEnabled]);

  return {
    data,
    loading,
  };
};

export default useFetchData;
